import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';
import fonts from 'styles/fonts';

const useStyles = makeStyles({
  inputList: {
    '& .MuiInputBase-root': {
      height: 'auto',
    },
    '& .MuiIconButton-root': {
      color: colors.black,
    },
    paddingBottom: '24px',
  },
  inputText: {
    '& .MuiInputBase-root': {
      height: '58px',
    },
    paddingBottom: '24px',
  },
  formMessage: {
    fontSize: '14px',
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '16px',
    marginBottom: '24px',
  },

  formControl: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'spacing-beetwen',

    '& .MuiFormGroup-root': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'spacing-beetwen',
    },
  },
  formLabel: {
    display: 'flex',
    flexDirection: 'row',
    paddingInlineEnd: '50px',
  },
  labelMessage: { marginLeft: '5px' },
});

export default useStyles;
